const useBaseImageUrl = () => {
  return 'https://uas.edu.ye';
};

export default useBaseImageUrl;
